// extracted by mini-css-extract-plugin
module.exports = {"Photos":"WallGallery_Photos__1pdCt"};